import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/site/img/ORCID-iD_icon_unauth_vector.svg'


const _hoisted_1 = {
  class: "flex flex-col items-center w-full h-full bg-tethys-1 overflow-hidden",
  autocomplete: "off"
}
const _hoisted_2 = {
  key: 0,
  class: "py-5"
}
const _hoisted_3 = { class: "w-[90vw] sm:w-[75vw] 2xl:w-[67vw] mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap" }
const _hoisted_5 = { class: "w-full lg:w-8/12" }
const _hoisted_6 = { class: "flex justify-between items-center" }
const _hoisted_7 = { class: "px-2 py-2 text-sm text-gray-400 uppercase" }
const _hoisted_8 = { class: "bg-white border shadow-xl rounded-xl" }
const _hoisted_9 = { class: "flex justify-end items-center pt-3 pb-2 pr-4" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  class: "flex flex-wrap px-5 pb-4"
}
const _hoisted_15 = { class: "w-full font-bold text-black text-base sm:text-xl" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "inline-block px-5 pb-4" }
const _hoisted_21 = ["title"]
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "text-gray-500 px-5 pb-12" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "flex flex-wrap gap-1 items-center" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block bg-black text-white text-xs rounded px-2 py-1 whitespace-nowrap" }
const _hoisted_28 = {
  key: 1,
  class: "pr-1"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 1,
  class: "flex flex-wrap text-sm sm:text-base px-5 pb-10"
}
const _hoisted_31 = { class: "w-full" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "flex flex-wrap px-5 pb-5" }
const _hoisted_37 = {
  key: 0,
  class: "w-full"
}
const _hoisted_38 = { class: "relative" }
const _hoisted_39 = { class: "hidden md:table w-full mb-4 text-xs" }
const _hoisted_40 = { class: "text-left" }
const _hoisted_41 = { class: "border-b-2 border-gray-200 bg-gray-100" }
const _hoisted_42 = { class: "text-gray-500 px-4 py-3" }
const _hoisted_43 = { class: "text-gray-500 px-4 py-3" }
const _hoisted_44 = { class: "text-gray-500 px-4 py-3" }
const _hoisted_45 = { class: "text-gray-500 px-4 py-3" }
const _hoisted_46 = ["title"]
const _hoisted_47 = { class: "border-b-2 border-gray-200 px-4 py-3" }
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "border-b-2 border-gray-200 px-4 py-3" }
const _hoisted_50 = { class: "border-b-2 border-gray-200 px-4 py-3" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["title", "href"]
const _hoisted_53 = { class: "hidden xl:inline pl-1" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["title", "onClick"]
const _hoisted_56 = { class: "hidden xl:inline pl-1" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["title"]
const _hoisted_59 = { class: "hidden xl:inline pl-1" }
const _hoisted_60 = { class: "font-sans font-bold uppercase text-gray-500 text-base" }
const _hoisted_61 = { class: "truncate mb-1" }
const _hoisted_62 = ["href"]
const _hoisted_63 = { class: "mb-1" }
const _hoisted_64 = {
  key: 0,
  class: "absolute inset-0 bg-tethys-blue1-light bg-opacity-80 flex items-center justify-center text-tethys-blue1-dark text-center text-xs md:text-lg p-4 rounded-lg"
}
const _hoisted_65 = { class: "font-semibold" }
const _hoisted_66 = { class: "font-bold" }
const _hoisted_67 = { class: "hidden md:inline" }
const _hoisted_68 = { class: "font-bold text-base" }
const _hoisted_69 = {
  key: 0,
  class: "font-bold text-xs pl-2 text-tethys-blue2-dark"
}
const _hoisted_70 = { key: 0 }
const _hoisted_71 = ["src"]
const _hoisted_72 = { key: 1 }
const _hoisted_73 = { class: "overflow-auto max-h-[500px] sm:max-w-3xl lg:max-w-5xl border border-gray-300" }
const _hoisted_74 = { class: "table-auto w-full text-left border-collapse" }
const _hoisted_75 = { class: "bg-gray-100 sticky top-0 z-10" }
const _hoisted_76 = {
  key: 0,
  class: "text-gray-600 py-2"
}
const _hoisted_77 = {
  key: 0,
  class: "text-center text-gray-500 py-4"
}
const _hoisted_78 = { key: 2 }
const _hoisted_79 = ["src"]
const _hoisted_80 = { key: 3 }
const _hoisted_81 = { class: "text-gray-500" }
const _hoisted_82 = {
  key: 0,
  class: "font-bold text-base"
}
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  key: 0,
  class: "flex flex-wrap mb-8 mt-3"
}
const _hoisted_85 = { class: "w-full font-bold uppercase mb-4" }
const _hoisted_86 = {
  key: 0,
  class: "w-full justify-normal"
}
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = {
  key: 1,
  class: "flex flex-wrap mb-8"
}
const _hoisted_93 = { class: "w-full font-bold uppercase mb-4" }
const _hoisted_94 = {
  key: 0,
  class: "w-full"
}
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { key: 1 }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "flex flex-wrap mb-8" }
const _hoisted_101 = { class: "w-full font-bold uppercase mb-2" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { class: "flex flex-wrap mb-8" }
const _hoisted_105 = { class: "w-full font-bold uppercase mb-2" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = { class: "flex flex-wrap mb-1" }
const _hoisted_109 = { class: "w-full font-bold uppercase mb-2" }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { key: 1 }
const _hoisted_112 = {
  key: 0,
  class: "font-bold text-base"
}
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { class: "relative block" }
const _hoisted_115 = { class: "pb-6" }
const _hoisted_116 = ["href"]
const _hoisted_117 = ["title"]
const _hoisted_118 = { class: "w-full lg:w-4/12 lg:pl-5 2xl:pl-10" }
const _hoisted_119 = { class: "flex justify-end items-center" }
const _hoisted_120 = { class: "px-2 py-2 text-sm text-gray-400 uppercase" }
const _hoisted_121 = { class: "bg-white border shadow-xl rounded-xl p-5 mb-5" }
const _hoisted_122 = { class: "py-5" }
const _hoisted_123 = { class: "text-gray-500 text-xs font-bold" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { key: 1 }
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { key: 1 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { class: "flex text-gray-500 text-sm pb-5" }
const _hoisted_132 = { class: "font-semibold pb-3 pr-5" }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_135 = ["title"]
const _hoisted_136 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_137 = {
  key: 1,
  class: "flex flex-wrap gap-1"
}
const _hoisted_138 = ["title"]
const _hoisted_139 = ["href"]
const _hoisted_140 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_141 = { key: 1 }
const _hoisted_142 = { class: "flex text-gray-500 text-sm pb-5" }
const _hoisted_143 = { class: "font-semibold pb-3 pr-5" }
const _hoisted_144 = { key: 0 }
const _hoisted_145 = { class: "font-normal px-2" }
const _hoisted_146 = {
  key: 0,
  target: "_blank",
  class: "text-gray-400",
  href: 'https://creativecommons.org/licenses/by/4.0/'
}
const _hoisted_147 = { class: "text-tethys-blue2-dark hover:underline pl-1" }
const _hoisted_148 = {
  key: 1,
  target: "_blank",
  class: "text-gray-400",
  href: 'https://creativecommons.org/licenses/by-sa/4.0/'
}
const _hoisted_149 = { class: "text-tethys-blue2-dark hover:underline pl-1" }
const _hoisted_150 = { class: "text-gray-500 pb-5" }
const _hoisted_151 = { class: "font-semibold pb-2 mb-3 border-b-2 border-gray-200" }
const _hoisted_152 = { key: 0 }
const _hoisted_153 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_154 = {
  key: 1,
  class: "flex flex-wrap gap-1"
}
const _hoisted_155 = ["href", "title"]
const _hoisted_156 = { key: 1 }
const _hoisted_157 = { class: "text-gray-500 pb-5" }
const _hoisted_158 = { class: "font-semibold pb-2 mb-3 border-b-2 border-gray-200" }
const _hoisted_159 = { key: 0 }
const _hoisted_160 = ["title"]
const _hoisted_161 = { class: "relative w-full max-w-xl p-5 bg-white rounded-lg shadow" }
const _hoisted_162 = { class: "flex items-start justify-between p-4 mb-4 border-b rounded-t" }
const _hoisted_163 = { class: "text-sm font-bold text-gray-700 bg-white rounded-md border border-gray-300 shadow-sm px-2 py-1" }
const _hoisted_164 = { class: "font-semibold italic text-left pl-3 py-1" }
const _hoisted_165 = { class: "p-4 text-justify" }
const _hoisted_166 = { key: 1 }
const _hoisted_167 = { class: "text-gray-500 pb-5" }
const _hoisted_168 = { class: "font-semibold pb-2 mb-3 border-b-2 border-gray-200" }
const _hoisted_169 = { class: "bg-white border shadow-xl rounded-xl p-5 mb-5" }
const _hoisted_170 = { class: "font-semibold" }
const _hoisted_171 = { class: "border-t-2 border-gray-200 pt-4" }
const _hoisted_172 = { key: 0 }
const _hoisted_173 = { class: "pl-2 text-sm" }
const _hoisted_174 = { key: 0 }
const _hoisted_175 = ["href"]
const _hoisted_176 = {
  key: 1,
  class: "text-gray-700"
}
const _hoisted_177 = { key: 0 }
const _hoisted_178 = ["href"]
const _hoisted_179 = {
  key: 1,
  class: "block text-sm italic pb-2 pl-4"
}
const _hoisted_180 = { key: 1 }
const _hoisted_181 = { class: "bg-white border shadow-xl rounded-xl p-5 mb-8" }
const _hoisted_182 = { class: "font-semibold" }
const _hoisted_183 = { class: "border-t-2 border-gray-200 pt-4" }
const _hoisted_184 = { class: "font-semibold" }
const _hoisted_185 = { class: "font-semibold" }
const _hoisted_186 = { key: 0 }
const _hoisted_187 = { class: "font-semibold" }
const _hoisted_188 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_MiniMap = _resolveComponent("MiniMap")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('published') + ": " + _ctx.getSimpleDate(_ctx.dataset.server_date_published)), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("span", {
                      class: "inline-block px-3 py-1 text-xs font-normal text-tethys-blue1-dark italic bg-tethys-blue1-light rounded-xl shadow-sm",
                      title: _ctx.$t('data_type')
                    }, [
                      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-file pr-1" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.dataset.type)), 1)
                    ], 8, _hoisted_10),
                    (_ctx.dataset.hasLicenses())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataset.licenses, (license) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: license.id
                            }, [
                              (_ctx.openAccessLicences.includes(license.name))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "inline-block px-3 mb-0.5 py-1 text-xs font-normal text-tethys-blue1-dark bg-tethys-blue1-light rounded-xl shadow-sm ml-2 sm:ml-0",
                                    title: _ctx.$t('license_open')
                                  }, _cache[5] || (_cache[5] = [
                                    _createElementVNode("i", { class: "fas fa-lock-open" }, null, -1)
                                  ]), 8, _hoisted_12))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.dataset.hasEmbargoPassed())
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "inline-block px-3 py-1 text-xs font-normal text-tethys-orange bg-tethys-blue1-light rounded-xl shadow-sm ml-2 sm:ml-0",
                          title: _ctx.$t('dataset_under_embargo_icon')
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("i", { class: "fa-solid fa-hourglass-half" }, null, -1)
                        ]), 8, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.dataset.hasOwnProperty('titles'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, [
                          (_ctx.dataset.MainTitle?.language.toUpperCase() == _ctx.$i18n.locale)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.dataset.MainTitle?.value), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                (_ctx.dataset.hasTranslatedTitle())
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.dataset.TranslatedTitle?.value), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.dataset.MainTitle?.value), 1))
                              ]))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_20, [
                    _createElementVNode("span", {
                      class: "px-2 py-1.5 text-xs font-bold text-gray-500 bg-gray-200 rounded shadow-sm",
                      title: _ctx.$t('data_type')
                    }, " DOI ", 8, _hoisted_21),
                    (_ctx.dataset.identifier)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          target: "_blank",
                          href: 'https://doi.org/' + _ctx.dataset.identifier.value,
                          class: "text-tethys-4 text-xs sm:text-sm pl-2"
                        }, _toDisplayString("https://doi.org/" + _ctx.dataset.identifier.value), 9, _hoisted_22))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.dataset.authors.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorsList, (author, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index,
                                class: "flex items-center text-xs sm:text-base"
                              }, [
                                _createElementVNode("span", null, _toDisplayString(author.displayName), 1),
                                (author.identifier_orcid != null)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: 'https://orcid.org/' + author.identifier_orcid,
                                      target: "_blank",
                                      class: "relative group pl-1 pr-0.5"
                                    }, [
                                      _cache[7] || (_cache[7] = _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: "ORCID Logo",
                                        class: "w-4 h-4"
                                      }, null, -1)),
                                      _createElementVNode("span", _hoisted_27, _toDisplayString(author.displayName + " - " + _ctx.$t('visit_orcid')), 1)
                                    ], 8, _hoisted_26))
                                  : _createCommentVNode("", true),
                                (index < _ctx.authorsList.length - 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(";")))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_29, "-"))
                  ]),
                  (_ctx.dataset.hasOwnProperty('abstracts'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          (_ctx.dataset.MainAbstract?.language.toUpperCase() == _ctx.$i18n.locale)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.dataset.MainAbstract?.value), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                (_ctx.dataset.hasTranslatedAbstract())
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.dataset.TranslatedAbstract?.value), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.dataset.MainAbstract?.value), 1))
                              ]))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_36, [
                    (_ctx.dataset.files.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("table", _hoisted_39, [
                              _createElementVNode("thead", _hoisted_40, [
                                _createElementVNode("tr", _hoisted_41, [
                                  _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.$t('file')), 1),
                                  _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.$t('format')), 1),
                                  _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.$t('size')), 1),
                                  _createElementVNode("th", _hoisted_45, _toDisplayString(_ctx.$t('action')), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataset.files, (file) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: file.id,
                                    class: "hover:bg-gray-50 text-gray-600"
                                  }, [
                                    _createElementVNode("td", {
                                      class: "max-w-48 truncate border-b-2 border-gray-200 px-4 py-3",
                                      title: file.label
                                    }, _toDisplayString(file.label), 9, _hoisted_46),
                                    _createElementVNode("td", _hoisted_47, [
                                      _createElementVNode("span", {
                                        class: "px-2 py-1 text-xs font-bold text-gray-400 bg-gray-200 rounded shadow-sm",
                                        title: _ctx.$t('data_type')
                                      }, _toDisplayString(_ctx.getExtension(file.path_name)), 9, _hoisted_48)
                                    ]),
                                    _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.formatSize(file.file_size)), 1),
                                    _createElementVNode("td", _hoisted_50, [
                                      (_ctx.dataset.hasEmbargoPassed())
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                            _createElementVNode("a", {
                                              class: "px-2 py-1.5 border border-tethys-4 shadow-sm bg-tethys-blue2-dark hover:bg-tethys-blue1-dark hover:border-tethys-blue1-dark text-white transition-colors rounded-md cursor-pointer",
                                              title: _ctx.$t('download_file'),
                                              target: "_blank",
                                              href: _ctx.portal + file.id
                                            }, [
                                              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-download text-xs" }, null, -1)),
                                              _cache[9] || (_cache[9] = _createTextVNode()),
                                              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('download')), 1)
                                            ], 8, _hoisted_52),
                                            (_ctx.isFileSupported(_ctx.getExtension(file.path_name)))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(['ml-1 px-2 py-1.5 border border-gray-300 shadow-sm hover:bg-gray-300 text-gray-500 transition-colors rounded-md cursor-pointer', 
                                                                    { 'text-tethys-blue2-dark bg-tethys-blue1-light border-tethys-blue1-light': _ctx.fileLabel === file.label }]),
                                                    title: _ctx.$t('preview_file'),
                                                    onClick: ($event: any) => (_ctx.previewFile(file.label, _ctx.getExtension(file.path_name), _ctx.portal + file.id))
                                                  }, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa-solid fa-eye text-xs" }, null, -1)),
                                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                                    _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('view')), 1)
                                                  ], 10, _hoisted_55)
                                                ]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_57, [
                                                  _createElementVNode("span", {
                                                    class: "ml-1 px-2 py-1.5 border border-gray-300 shadow-sm text-gray-500 rounded-md cursor-not-allowed",
                                                    title: _ctx.$t('preview_not_supported')
                                                  }, [
                                                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa-solid fa-eye-slash text-xs" }, null, -1)),
                                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                                    _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('view')), 1)
                                                  ], 8, _hoisted_58)
                                                ]))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createVNode(_component_Accordion, {
                              class: "block md:hidden pb-1",
                              customClass: "left-panel",
                              itemCount: 1
                            }, {
                              title: _withCtx(({ index }) => [
                                _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t('files')), 1)
                              ]),
                              content: _withCtx(({ index }) => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataset.files, (file) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: file.id,
                                    class: "border-b border-b-gray-300m text-sm mb-1 p-4"
                                  }, [
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("a", {
                                        target: "_blank",
                                        href: _ctx.portal + file.id,
                                        class: "text-primary-tethys font-bold hover:underline"
                                      }, [
                                        _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-file-download mr-1" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(file.label), 1)
                                      ], 8, _hoisted_62)
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('format') + ': '), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getExtension(file.path_name)), 1)
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('size') + ': '), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatSize(file.file_size)), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            (!_ctx.dataset.hasEmbargoPassed())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  _createElementVNode("p", _hoisted_65, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('dataset_under_embargo') + ": ") + " ", 1),
                                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.getSimpleDate(_ctx.dataset.embargo_date)), 1),
                                    _cache[15] || (_cache[15] = _createTextVNode()),
                                    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('meanwhile_access_restricted')), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Accordion, {
                    class: "hidden md:block px-5 pb-5",
                    customClass: "left-panel",
                    itemCount: 1,
                    ref: "previewAccordion"
                  }, {
                    title: _withCtx(({ index }) => [
                      _createElementVNode("div", _hoisted_68, [
                        _createTextVNode(_toDisplayString(_ctx.$t('preview_file') + ": ") + " ", 1),
                        (_ctx.fileLabel != '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.fileLabel + "." + _ctx.fileType), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    content: _withCtx(({ index }) => [
                      (_ctx.fileType === 'pdf')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            _createElementVNode("iframe", {
                              src: _ctx.fileUrl,
                              width: "100%",
                              height: "500px",
                              frameborder: "0",
                              class: "border border-gray-300"
                            }, null, 8, _hoisted_71)
                          ]))
                        : (_ctx.fileType === 'csv' || _ctx.fileType === 'txt')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("table", _hoisted_74, [
                                  _createElementVNode("thead", _hoisted_75, [
                                    _createElementVNode("tr", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textHeaders, (header, idx) => {
                                        return (_openBlock(), _createElementBlock("th", {
                                          key: 'header-' + idx,
                                          scope: "col",
                                          class: "border-b border-gray-300 px-1 py-1 text-xs font-semibold text-gray-700 whitespace-normal"
                                        }, _toDisplayString(header), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textRows, (row, idx) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: 'row-' + idx,
                                        class: "hover:bg-gray-100"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, i) => {
                                          return (_openBlock(), _createElementBlock("td", {
                                            key: 'cell-' + idx + '-' + i,
                                            class: "border-b border-gray-200 px-1 py-1 text-xs text-gray-600 whitespace-nowrap"
                                          }, _toDisplayString(cell), 1))
                                        }), 128))
                                      ]))
                                    }), 128))
                                  ]),
                                  (_ctx.fileType === 'txt')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, " ... only the first 100 lines are previewed ... "))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (!_ctx.textHeaders.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, " No data available to display. "))
                                : _createCommentVNode("", true)
                            ]))
                          : (_ctx.fileType === 'jpg' || _ctx.fileType === 'png')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                _createElementVNode("img", {
                                  src: _ctx.fileUrl,
                                  alt: "Image Preview",
                                  class: "max-w-full border border-gray-300"
                                }, null, 8, _hoisted_79)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.$t('click_in_preview_icon')), 1)
                              ]))
                    ]),
                    _: 1
                  }, 512),
                  _createVNode(_component_Accordion, {
                    class: "px-5 pb-5",
                    itemCount: 1,
                    customClass: "left-panel"
                  }, {
                    title: _withCtx(({ index }) => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(_ctx.$t('further_details')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    content: _withCtx(({ index }) => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            (_ctx.dataset.hasOwnProperty('abstracts'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                  _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t('method') + ':'), 1),
                                  (_ctx.dataset.hasMethodsAbstract())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                                        (_ctx.dataset.MethodsAbstract?.language.toUpperCase() == _ctx.$i18n.locale)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_87, [
                                              _createElementVNode("p", null, _toDisplayString(_ctx.dataset.MethodsAbstract?.value), 1)
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_88, [
                                              (_ctx.dataset.hasTranslatedMethodsAbstract())
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString(_ctx.dataset.TranslatedMethodsAbstract?.value), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_ctx.dataset.MethodsAbstract?.value), 1))
                                            ]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_91, "-"))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.dataset.hasOwnProperty('abstracts'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                  _createElementVNode("span", _hoisted_93, _toDisplayString(_ctx.$t('series_information') + ':'), 1),
                                  (_ctx.dataset.hasSeriesInformationAbstract())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, [
                                        (_ctx.dataset.SeriesInformationAbstract?.language.toUpperCase() == _ctx.$i18n.locale)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_95, [
                                              _createElementVNode("p", null, _toDisplayString(_ctx.dataset.SeriesInformationAbstract?.value), 1)
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_96, [
                                              (_ctx.dataset.hasTranslatedSeriesInformationAbstract())
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.dataset.TranslatedSeriesInformationAbstract?.value), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString(_ctx.dataset.SeriesInformationAbstract?.value), 1))
                                            ]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_99, "-"))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$t('publication_language') + ':'), 1),
                              (_ctx.getLanguage(_ctx.dataset.language) == 'Deutsch')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.$t('german')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(_ctx.$t('english')), 1))
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("span", _hoisted_105, _toDisplayString(_ctx.$t('embargo') + ':'), 1),
                              (_ctx.dataset.embargo_date)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(_ctx.getHumanDate(_ctx.dataset.embargo_date)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_107, "-"))
                            ]),
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('contributor') + ':'), 1),
                              (_ctx.dataset.hasContributors())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(_ctx.dataset.contributors.map((u) => u.full_name).join(", ")), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_111, "-"))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Accordion, {
                    class: "px-5 pb-6",
                    itemCount: 1,
                    customClass: "left-panel"
                  }, {
                    title: _withCtx(({ index }) => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_112, _toDisplayString(_ctx.$t('citation')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    content: _withCtx(({ index }) => [
                      (index === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("p", _hoisted_115, [
                                _createTextVNode(_toDisplayString(_ctx.getCitation()) + " ", 1),
                                (_ctx.dataset.identifier)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      target: "_blank",
                                      class: "text-tethys-blue2-dark hover:underline",
                                      href: 'https://doi.org/' + _ctx.dataset.identifier.value
                                    }, " (" + _toDisplayString("https://doi.org/" + _ctx.dataset.identifier.value) + ") ", 9, _hoisted_116))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.dataset.identifier.value.toString()))),
                                class: "absolute bottom-0 right-0 cursor-pointer px-2 py-1 text-xs font-normal rounded-md border border-gray-300 shadow-sm hover:bg-gray-200",
                                title: _ctx.$t('copy_citation_tooltip')
                              }, [
                                _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa-regular fa-clone pr-1" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('copy_citation')), 1)
                              ], 8, _hoisted_117)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.$t('details')), 1)
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_MiniMap, {
                      bounds: _ctx.dataset.Bounds,
                      class: "relative z-10 rounded-lg"
                    }, null, 8, ["bounds"])
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _createVNode(_component_Accordion, {
                      customClass: "coverageContainer",
                      itemCount: 1
                    }, {
                      title: _withCtx(({ index }) => [
                        _createElementVNode("h3", _hoisted_123, _toDisplayString(_ctx.$t('coverage')) + ":", 1)
                      ]),
                      content: _withCtx(({ index }) => [
                        _createVNode(_component_Accordion, {
                          customClass: "coverage",
                          itemCount: _ctx.coverageAttributes.length
                        }, {
                          title: _withCtx(({ index }) => [
                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.coverageAttributes[index].key)), 1)
                          ]),
                          content: _withCtx(({ index }) => [
                            (_ctx.coverageAttributes[index].values)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverageAttributes[index].values, (value, label) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: label }, [
                                      value
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_125, [
                                            (_ctx.coverageAttributes[index].key == 'geolocation')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_126, _toDisplayString(_ctx.$t(label) + ": " + value.toFixed(6)), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_127, [
                                                  (_ctx.coverageAttributes[index].key == 'elevation' || _ctx.coverageAttributes[index].key == 'depth')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_128, _toDisplayString(_ctx.$t(label) + ": " + Intl.NumberFormat('de-de').format(value) + " m."), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_129, _toDisplayString(_ctx.$t(label) + ": " + value), 1))
                                                ]))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_130, "No data available"))
                          ]),
                          _: 2
                        }, 1032, ["itemCount"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("p", _hoisted_132, _toDisplayString(_ctx.$t('creator') + ':'), 1),
                    (_ctx.dataset.authors.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_133, [
                          (_ctx.accessNotFromDoi())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_134, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorsList, (author, index) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: index,
                                    class: "pb-1 pr-1",
                                    title: _ctx.$t('search_creator')
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: { name: 'Search', params: { display: author.lastName, type: 'authors' } },
                                      class: "underline text-sm text-gray-400 hover:bg-gray-200 transition-colors"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(author.displayName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]),
                                    (index < _ctx.authorsList.length - 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_136, ";"))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_135))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_137, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorsList, (author, index) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: index,
                                    class: "pb-1 pr-1",
                                    title: _ctx.$t('search_creator')
                                  }, [
                                    _createElementVNode("a", {
                                      target: "_blank",
                                      href: _ctx.search_url + '/' + author.lastName + '/authors',
                                      class: "text-sm text-gray-400 hover:bg-gray-200 transition-colors"
                                    }, _toDisplayString(author.displayName), 9, _hoisted_139),
                                    (index < _ctx.authorsList.length - 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_140, ";"))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_138))
                                }), 128))
                              ]))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_141, "-"))
                  ]),
                  _createElementVNode("div", _hoisted_142, [
                    _createElementVNode("p", _hoisted_143, _toDisplayString(_ctx.$t('license') + ':'), 1),
                    (_ctx.dataset.hasLicenses())
                      ? (_openBlock(), _createElementBlock("p", _hoisted_144, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataset.licenses, (license) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: license.id
                            }, [
                              _createElementVNode("span", _hoisted_145, [
                                (license.name=='CC-BY-4.0')
                                  ? (_openBlock(), _createElementBlock("a", _hoisted_146, [
                                      _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa-brands fa-creative-commons" }, null, -1)),
                                      _createElementVNode("span", _hoisted_147, _toDisplayString(license.name), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("a", _hoisted_148, [
                                      _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa-brands fa-creative-commons" }, null, -1)),
                                      _createElementVNode("span", _hoisted_149, _toDisplayString(license.name), 1)
                                    ]))
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("p", _hoisted_151, _toDisplayString(_ctx.$t('keywords') + ':'), 1),
                    (_ctx.dataset.hasOwnProperty('subjects'))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_152, [
                          (_ctx.accessNotFromDoi())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_153, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataset.subjects, (subject, index) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: subject.value,
                                    class: "pb-2 flex-shrink-0"
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: { name: 'Search', params: { display: subject.value, type: 'subjects' } },
                                      class: "px-2 py-1 text-xs text-tethys-blue2-dark bg-tethys-blue2-light rounded-xl border border-tethys-2 shadow-sm hover:bg-tethys-blue1-dark hover:text-white hover:border-tethys-blue1-dark transition-colors",
                                      title: _ctx.$t('search_keyword')
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(subject.value), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "title"])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_154, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataset.subjects, (subject, index) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: subject.value,
                                    class: "pb-2 flex-shrink-0"
                                  }, [
                                    _createElementVNode("a", {
                                      target: "_blank",
                                      href: _ctx.search_url + '/' + subject.value + '/subjects',
                                      class: "px-2 py-1 text-xs text-tethys-blue2-dark bg-tethys-blue2-light rounded-xl border border-tethys-2 shadow-sm hover:bg-tethys-blue1-dark hover:text-white hover:border-tethys-blue1-dark transition-colors",
                                      title: _ctx.$t('search_keyword')
                                    }, _toDisplayString(subject.value), 9, _hoisted_155)
                                  ]))
                                }), 128))
                              ]))
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_156, "-"))
                  ]),
                  _createElementVNode("div", _hoisted_157, [
                    _createElementVNode("p", _hoisted_158, _toDisplayString(_ctx.$t('project') + ':'), 1),
                    (_ctx.dataset.project != null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_159, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.dataset.project.label), 1),
                          _createElementVNode("i", {
                            class: "fas fa-circle-info text-tethys-blue1-dark hover:text-black pl-1",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showProjectModal && _ctx.showProjectModal(...args))),
                            title: _ctx.$t('project_details')
                          }, null, 8, _hoisted_160),
                          (_ctx.isShowProjectModal)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeProjectModal && _ctx.closeProjectModal(...args)), ["self"])),
                                class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("div", _hoisted_161, [
                                  _createElementVNode("div", _hoisted_162, [
                                    _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.dataset.project?.label), 1),
                                    _createElementVNode("p", _hoisted_164, _toDisplayString(_ctx.dataset.project?.name), 1),
                                    _createElementVNode("button", {
                                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeProjectModal && _ctx.closeProjectModal(...args))),
                                      type: "button",
                                      class: "text-gray-400 hover:text-gray-900 py-1"
                                    }, _cache[20] || (_cache[20] = [
                                      _createElementVNode("svg", {
                                        class: "w-5 h-5",
                                        fill: "currentColor",
                                        viewBox: "0 0 20 20",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }, [
                                        _createElementVNode("path", {
                                          "fill-rule": "evenodd",
                                          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                          "clip-rule": "evenodd"
                                        })
                                      ], -1)
                                    ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_165, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.dataset.project.description), 1)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_166, "-"))
                  ]),
                  _createElementVNode("div", _hoisted_167, [
                    _createElementVNode("p", _hoisted_168, _toDisplayString(_ctx.$t('publisher') + ':'), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.dataset.publisher_name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _createVNode(_component_Accordion, {
                    class: "",
                    customClass: "right-panel",
                    itemCount: 1,
                    ref: "referencesAccordion"
                  }, {
                    title: _withCtx(({ index }) => [
                      _createElementVNode("div", _hoisted_170, _toDisplayString(_ctx.$t('references')), 1)
                    ]),
                    content: _withCtx(({ index }) => [
                      _createElementVNode("div", _hoisted_171, [
                        (_ctx.dataset.references.length> 0)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_172, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataset.references, (reference, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: reference.id,
                                  class: "pb-2"
                                }, [
                                  _createElementVNode("p", null, [
                                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa-solid fa-right-to-bracket text-tethys-blue1-dark pb-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_173, _toDisplayString(_ctx.$t(reference.relation) + ":"), 1)
                                  ]),
                                  (reference.type == 'DOI' || reference.type == 'URL')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_174, [
                                        _createElementVNode("a", {
                                          target: "_blank",
                                          class: "block text-sm italic text-tethys-4 hover:underline pb-2 pl-5",
                                          href: reference.value
                                        }, _toDisplayString(reference.label), 9, _hoisted_175)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_176, [
                                        (reference.value.indexOf('85316') != -1 || reference.value.indexOf('900312') != -1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_177, [
                                              _createElementVNode("a", {
                                                target: "_blank",
                                                class: "block text-sm italic text-tethys-blue2-dark hover:underline pb-2 pl-4",
                                                href: 'https://bibliothek.geosphere.at/cgi-bin/koha/opac-search.pl?idx=&q=' + reference.value
                                              }, _toDisplayString(`(${reference.type}): ${reference.value}`), 9, _hoisted_178)
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_179, _toDisplayString(`(${reference.type}): ${reference.value}`), 1))
                                      ]))
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_180, _toDisplayString(_ctx.$t('no_linked_references')), 1))
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _createElementVNode("div", _hoisted_181, [
                  _createVNode(_component_Accordion, {
                    class: "",
                    customClass: "right-panel",
                    itemCount: 1
                  }, {
                    title: _withCtx(({ index }) => [
                      _createElementVNode("div", _hoisted_182, _toDisplayString(_ctx.$t('technical_metadata')), 1)
                    ]),
                    content: _withCtx(({ index }) => [
                      _createElementVNode("div", _hoisted_183, [
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_184, _toDisplayString(_ctx.$t('persistent_identifier') + ': '), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.dataset.url), 1)
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_185, _toDisplayString(_ctx.$t('status') + ': '), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.dataset.server_state), 1)
                        ]),
                        (_ctx.dataset.hasOwnProperty('user'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_186, [
                              _createElementVNode("span", _hoisted_187, _toDisplayString(_ctx.$t('posted_by') + ': '), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.dataset.user.login), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", null, [
                          _createElementVNode("span", _hoisted_188, _toDisplayString(_ctx.$t('editor') + ': '), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.dataset.creating_corporation), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}